import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';
import HotelRating from 'src/components/HotelRating';
import HotelRelink from '../HotelRelink';
import ReviewsList from '../../containers/Reviews/ReviewsList';
import Paper from '../Paper';

const baseCls = 'lt-hotel-reviews';

const ReviewsDesktop = ({
  isRatingExists,
  linkedHotels,
  searchParams,
  isWhitelabel,
}) => {
  const showLinkedHotels = !isWhitelabel && linkedHotels.length > 0;
  const { t } = useTranslation();

  return (
    <div className={baseCls}>
      <h2 className="like-h2">{t('hotel.reviews.title')}</h2>
      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__list`}>
          <div className={`${baseCls}__items`}>
            <ReviewsList />
          </div>
        </div>
        {(isRatingExists || showLinkedHotels) && (
          <StyledRating>
            <HotelRating />
            {showLinkedHotels && (
              <Paper>
                <Heading>{t('hotel.similarHotels')}</Heading>
                <HotelRelink
                  hotels={linkedHotels}
                  searchParams={searchParams}
                />
              </Paper>
            )}
          </StyledRating>
        )}
      </div>
    </div>
  );
};

ReviewsDesktop.propTypes = {
  isRatingExists: PropTypes.bool.isRequired,
};

const Heading = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  margin-top: 6px;
  margin-bottom: 16px;
`;

const StyledRating = styled.div`
  margin-left: 8px;
  width: 332px;
  > div {
    margin-bottom: 8px;
  }
`;

export default ReviewsDesktop;
